<template>
  <section v-if="data?.deals?.length" v-show="!isDealsCardsVisible" id="nav-deals" class="nav-deals">
    <div class="nav-deals-scroller">
      <div class="nav-deals-wrap" @click="popupLinkHandler">
        <!-- eslint-disable vue/no-v-html -->
        <div v-if="data.heading" class="nav-deals-title" v-html="data.heading"></div>
        <!-- eslint-enable -->
        <ul v-if="data.deals?.length" class="nav-deals-list">
          <li v-for="(deal, index) of data.deals" :key="index">
            <Link :href="deal.value" @click="tagDeals(index + 1, getFullText(deal))">
              <b v-if="deal.heading">{{ deal.heading }}</b> <span v-if="deal.body">{{ deal.body }}</span>
            </Link>
          </li>
        </ul>
        <div v-if="data.allDealsLink?.value" class="nav-deals-all">
          <Link :href="data.allDealsLink.value" @click="tagDeals(getIndexForAllDeals(), data.allDealsLink.text)">
            <b>{{ data.allDealsLink.text }}</b>
            <i class="chevron-small-right-black"></i>
          </Link>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

import { GET_DEALS_DATA, GET_IS_MOBILE_VIEW } from '#shared/types/getters';
import Link from '../common/Link';
import { fireLinkTag } from '#shared/features/analytics/tagManager';
import { usePopupLink } from '~/composables/features/usePopupLink';

const navHeader = useNavHeader();
const navViewType = useNavViewType();
const { popupLinkHandler } = usePopupLink();
const data = computed(() => navHeader[GET_DEALS_DATA]);

const isMobile = computed(() => navViewType[GET_IS_MOBILE_VIEW]);
const isDealsCardsVisible = computed(() => isMobile.value && navHeader.isSearchModalActive);

function getFullText(deal) {
  const { heading = '', body = '' } = deal;

  return `${heading} ${body}`.trim();
}

function getIndexForAllDeals() {
  return data.value.deals?.length ? data.value.deals.length + 1 : 1;
}

function tagDeals(index, text = '') {
  const value = `skinny deals banner:cta${index}:${text}`;
  const payload = {
    event_name: value,
    link_name: value,
  };

  fireLinkTag(payload);
}
</script>

<style lang="scss">
@import '~/assets/scss/mixins/index.scss';

$dealsHeight: 40px;
$holiday-gold: #e1c173;

.nav-deals {
  overflow: hidden;
  white-space: nowrap;
  height: $dealsHeight;
  background-color: $holiday-gold;
  color: $black;

  a {
    color: $black;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    @include breakpoint(medium up) {
      font-size: 14px;
      line-height: 20px;
    }
  }

  &-scroller {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 10px;
    margin-bottom: -10px;
    display: flex;
  }

  &-wrap {
    display: flex;
    margin: 0 auto;
    height: $dealsHeight;
  }

  &-title {
    font-size: 12px;
    font-weight: 700;
    padding: 0 16px 0 20px;
    line-height: $dealsHeight;

    @include breakpoint(medium up) {
      font-size: 14px;
    }
  }
}

.nav-deals-list {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;

  li {
    padding: 0 16px 0 17px;
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;

    &::after {
      content: '';
      display: block;
      width: 1px;
      height: 16px;
      position: absolute;
      left: 0;
      background-color: $black;
    }

    &:first-child {
      padding-left: 16px;

      &::after {
        display: none;
      }
    }
  }
}

.nav-deals-all {
  padding-left: 16px;
  padding-right: 20px;
  height: 100%;
  display: flex;
  align-items: center;

  a {
    display: flex;
    align-items: center;
  }

  i {
    margin-left: 4px;
  }
}
</style>
